import { Component, OnInit, OnDestroy } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { CustomerModel } from 'src/app/models/customer-model';
import { EventsService } from 'src/app/services/event/event.service';
import { TimeService } from 'src/app/services/time-service/time.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';

@Component({
  selector: 'app-online-time',
  templateUrl: './online-time.component.html',
  styleUrls: ['./online-time.component.scss']
})
export class OnlineTimeComponent implements OnInit, OnDestroy {
  public currentTime: any;
  public currentTimeTS: any;
  public firstLoginTime: any;
  public intervalId: any;
  public isAuthenticated: boolean = false;
  public onlineTime: any;
  public userSubscription: any;
  public timeServiceSubscription: any;
  public serverTime: any;
  public syncTimeInterval: any;
  public timeSinceLastTimeCall: Date | null = null;
  public timeDifferenceToTheMinute: number = 0;
  public timeDifferenceToTheSeconds: number = 0;

  constructor(
    private eventsService: EventsService,
    private timeService: TimeService,
    private userSessionService: UserSessionService
  ) {
    // Subscribe to login event
    this.eventsService.subscribe("event:login", () => {
      this.verifyAuth();
      this.setUserTime();
    });

    // Subscribe to logout and signup events
    this.eventsService.subscribe("event:authentication:logout", () => {
      this.verifyAuth();
    });

    this.eventsService.subscribe("event:signupResult:flag", () => {
      this.verifyAuth();
    });
  }

  ngOnInit() {
    this.verifyAuth();
    this.setUserTime();
  }

  verifyAuth() {
    this.userSessionService.isAuthenticated().then((isAuthenticated) => {
      this.isAuthenticated = isAuthenticated;
    });
  }

  setUserTime() {
    this.onlineTime = null;
    this.serverTime = null;
    if (this.intervalId) clearInterval(this.intervalId);
    if (this.userSubscription) this.userSubscription.unsubscribe();
    
    this.userSubscription = this.userSessionService.getCustomer().pipe(
      filter(value => value != undefined),
      take(1)
    ).subscribe((customer: CustomerModel) => {
      if (customer) {
        this.timeFunction(customer.currentLoginTime).then((data) => {
          if (data) {
            let difference: any = data;
            this.timeDifferenceToTheSeconds =
              60 - new Date(difference * 1000).getSeconds();
            setTimeout(() => {
              this.timeFunction(customer.currentLoginTime);
              if (this.intervalId) {
                clearInterval(this.intervalId);
              }
              this.intervalId = setInterval(() => {
                this.timeFunction(customer.currentLoginTime);
              }, 60000);
            }, this.timeDifferenceToTheSeconds * 1000);
          }
        });
      }
    });
  }

  timeFunction(currentLoginTime?) {
    return new Promise((resolve, reject) => {
      if (this.timeServiceSubscription) this.timeServiceSubscription.unsubscribe();
      this.timeServiceSubscription = this.timeService.callTime().subscribe(
        (currentTime) => {
          if (currentTime.result == 1) {
            let createDate = new Date(currentLoginTime);
            this.firstLoginTime = Date.parse(String(createDate));
            this.serverTime = currentTime.payload.full;
            this.currentTimeTS = currentTime.payload.ts;
            let loggedInTime = this.firstLoginTime || this.currentTimeTS;
            this.onlineTime = this.timeService.getTimeOnline(
              this.currentTimeTS,
              loggedInTime
            );
            this.timeService.setOnlineTime(this.onlineTime);
            this.timeSinceLastTimeCall = new Date();
            clearInterval(this.syncTimeInterval);

            this.syncTimeInterval = setInterval(() => {
              const now = new Date();
              const diff = now.getTime() - this.timeSinceLastTimeCall.getTime();
              const adjustedServerDate = new Date(
                this.currentTimeTS * 1000 + diff
              );
              this.currentTime =
                (adjustedServerDate.getMonth() < 10 ? "0" : "") +
                (adjustedServerDate.getMonth() + 1) +
                "/" +
                adjustedServerDate.getDate() +
                "/" +
                adjustedServerDate.getFullYear() +
                " " +
                adjustedServerDate.getHours() +
                ":" +
                (adjustedServerDate.getMinutes() < 10 ? "0" : "") +
                adjustedServerDate.getMinutes() +
                " " +
                currentTime.payload.full.substr(-3);
            }, 1000);
          }
          resolve(this.currentTimeTS);
        },
        (error) => {
          resolve(0);
        }
      );
    });
  }

  ngOnDestroy() {
   // if (this.intervalId) clearInterval(this.intervalId);
    if (this.syncTimeInterval) clearInterval(this.syncTimeInterval);
    if (this.userSubscription) this.userSubscription.unsubscribe();
    if (this.timeServiceSubscription) this.timeServiceSubscription.unsubscribe();
  }
} 